export class PersonCriteria {
  pageNumber = 1;
  pageSize = 15;

  constructor(public name: string = null) {}
}
